import React from "react";
import {
  ArrayField,
  BooleanField,
  Datagrid,
  Labeled,
  ShowProps,
  TextField,
  UrlField,
} from "react-admin";
import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import CustomDateField from "components/CustomDateField";
import StatusField from "../../components/StatusField";

const Summary = (props: ShowProps) => {
  return (
    <>
      <SanitizedGrid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6">Subcontractor Detail</Typography>
        </Grid>

        <Grid item xs={3}>
          <Labeled source="Company Acra / Nric">
            <TextField source="businessRegistrationNumber" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={3}>
          <Labeled source="Code">
            <TextField source="id" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={3}>
          <Labeled source="Name">
            <TextField source="name" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={3}>
          <Labeled source="Person-in-charge">
            <TextField source="personInCharge" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={3}>
          <Labeled source="Include Goods and Services Tax">
            <BooleanField source="isGst" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={3}>
          <Labeled source="Status">
            <StatusField source="status" />
          </Labeled>
        </Grid>
        <Grid item xs={9}></Grid>

        <Grid item xs={12}>
          <Typography variant="h6">Contact Detail</Typography>
        </Grid>

        <Grid item xs={3}>
          <Labeled source="Contact">
            <TextField source="contactNumber" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={3}>
          <Labeled source="Email">
            <TextField source="email" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={3}></Grid>

        <Grid item xs={6}>
          <Labeled source="Address">
            <TextField source="address" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={3}>
          <Labeled source="Unit No.">
            <TextField source="unitNumber" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={3}>
          <Labeled source="Postal Code">
            <TextField source="postalCode" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={12}>
          <Typography variant="h6">Poc Numbers</Typography>
        </Grid>

        <Grid item xs={4}>
          <ArrayField source="pocNumbers" fieldKey="id">
            <Datagrid
              empty={<Typography variant="body2">No Result found</Typography>}
            >
              <TextField source="pocNumber" emptyText="-" />
            </Datagrid>
          </ArrayField>
        </Grid>
        <Grid item xs={8}></Grid>

        <Grid item xs={12}>
          <Typography variant="h6">Document Details</Typography>
        </Grid>

        <Grid item xs={6}>
          <ArrayField source="documents" fieldKey="id">
            <Datagrid
              empty={<Typography variant="body2">No Result found</Typography>}
            >
              <TextField source="type" emptyText="-" />
              <TextField source="serialNumber" emptyText="-" />
              <CustomDateField source="expiryDate" emptyText="-" />
              <UrlField source="fileUrl" emptyText="-" />
            </Datagrid>
          </ArrayField>
        </Grid>
        <Grid item xs={6}></Grid>
      </SanitizedGrid>
    </>
  );
};

export default Summary;
